<template>
  <div >
    <div >
      <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini" style="width: 100%;">
        <div class="formItemBox">
          <el-form-item label="休假开始时间" class="item2" >
          <el-date-picker
              v-model="searchFrom.holidayTimeStart"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="休假结束时间" class="item2" >
          <el-date-picker
              v-model="searchFrom.holidayTimeEnd"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
       <el-form-item label="司机姓名:">
          <el-input placeholder="" v-model="searchFrom.driverName" ></el-input>
        </el-form-item>
        <el-form-item label="流水编号:">
          <el-input placeholder="" v-model="searchFrom.holidayNo" ></el-input>
        </el-form-item>
        </div>
        <div style="display: flex;justify-content: space-between;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox">
            <el-button type="primary" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary"   size="mini" @click="resetForm('searchFrom')">重置</el-button>
          </div>
        </div>
      </el-form>
    </div>
      <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"  class="tableComent"   bordersize="mini"   @row-click="handleRowClick"
         style="width: 100%" height="100%"  center border>
       <el-table-column type="selection" width="55"></el-table-column>
       <el-table-column  type="index" width="55" label="序号"></el-table-column>
       <el-table-column label="操作" width="100" >
          <template slot-scope="scope">
            <div>
              <el-button  type="text" size="mini" v-if="btnFlg[0]" @click="delFn(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      <el-table-column prop="holidayNo" min-width="200"  :show-overflow-tooltip="true" :formatter="formatterRowEmpty" label="流水号"></el-table-column>
       <el-table-column prop="driverName" min-width="130"  :show-overflow-tooltip="true" :formatter="formatterRowEmpty"   label="司机"></el-table-column>
        <el-table-column prop="holidayTimeStart" label="休假开始时间" :formatter="dateTimeFormat" min-width="170"></el-table-column>
         <el-table-column prop="holidayTimeEnd" label="休假结束时间" :formatter="dateTimeFormat" min-width="170"></el-table-column>
      </el-table>
    </div>
      <!--分页-->
    <div class="pags" style="text-align: left;">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-size="searchFrom.pageSize"
        layout="prev, pager, next"
        @size-change="handleSizeChange"
        :total="total"
      ></el-pagination>
    </div>
    </div>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { formatterRowEmpty, dateTimeFormat, dateFormat } from '@/utils/util'
import { cDriverHolidayRecordListPC, delHolidayRecord, tTransportModelWarningrRadStatus, modelList } from '@/api/vgs-driver2.0'
export default {
  data () {
    return {
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      formatterRowEmpty: formatterRowEmpty,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: false,
      btnFlg: [],
      btnIdArr: ['00IM0C0500']
    }
  },
  created () {
    this.$set(this.searchFrom, 'plateNumber', this.$route.params.plateNumber)
    if (this.$route.params.time) {
      this.$set(this.searchFrom, 'createTime', this.$route.params.time)
    }
    this.getList(this.searchFrom)
    this.btnFlg = getBtn(this.btnIdArr, '/driverAttendance')
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 205) + 'px'
  },
  methods: {
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        delHolidayRecord({
          id: row.id, driverId: row.driverId
        }).then(res => {
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {

    },
    // 获取列表
    getList (searchFrom) {
      if (this.searchFrom.holidayTimeStart) {
        this.searchFrom.holidayTimeStart1 = this.searchFrom.holidayTimeStart[0]
        this.searchFrom.holidayTimeStart2 = this.searchFrom.holidayTimeStart[1]
      } else {
        this.searchFrom.holidayTimeStart1 = ''
        this.searchFrom.holidayTimeStart2 = ''
      }
      if (this.searchFrom.holidayTimeEnd) {
        this.searchFrom.holidayTimeEnd1 = this.searchFrom.holidayTimeEnd[0]
        this.searchFrom.holidayTimeEnd2 = this.searchFrom.holidayTimeEnd[1]
      } else {
        this.searchFrom.holidayTimeEnd1 = ''
        this.searchFrom.holidayTimeEnd2 = ''
      }
      this.loading = true
      cDriverHolidayRecordListPC(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
      this.searchFn()
    },

    closeDialog () {
      this.addFrom = {}
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.flag = false
    },
    tableStyle () {
      return 'height: 50px;'
    }
  }
}
</script>
<style lang="scss" scoped>
 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
